<template>
  <div class="winners-2021-place-winners-card-subtitle">
    <div class="winners-2021-place-winners-card-subtitle__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: "Winners2021PlaceWinnersCardSubtitle"
};
</script>

<style lang="scss">
.winners-2021-place-winners-card-subtitle {
  width: 100%;
  margin-bottom: 20px;

  text-align: center;
  font-weight: 700;
  font-size: 15px;

  display: flex;
  justify-content: center;
  align-items: center;

  &::before,
  &::after {
    content: "";
    display: block;
    border-bottom: 1px solid #444862;
    flex-grow: 1;
  }

  &__content {
    min-width: 145px;
    padding: 0 15px;
    line-height: 30px;
    height: 30px;
    background: rgba(#000a25, 0.7);
    border-radius: 4px;

    margin: 0 20px;
  }
}
</style>
